import { gsap } from 'gsap';
import Signal from '../../assets/scripts/classes/Signal';
import PageScroll from '../../assets/scripts/helpers/Scroll';

const HTML_CLASSLIST = document.documentElement.classList;

const OPEN_DURATION = 0.3;
const CLOSE_DURATION = 0.2;

class Modals {
	constructor() {
		this.init();
	}

	init() {
		this.wrappers = document.querySelectorAll('[data-modals]');

		if (!this.wrappers.length) return;

		this.onOpen = new Signal();
		this.onClose = new Signal();
		this.onCloseStart = new Signal();

		this.opened = false;
		this.openedClass = '';
		this.activePopup = null;
		this.activePopupName = '';
		this.activeWrapper = null;
		this.popups = document.querySelectorAll('[data-modal]');

		document.querySelectorAll('[data-modal-opener]').forEach((element) => {
			element.addEventListener('click', (e) => {
				e.preventDefault();
				this.open(e.currentTarget.getAttribute('data-modal-opener'));
			});
		});

		document.querySelectorAll('[data-modal-closer]').forEach((element) => {
			element.addEventListener('click', (e) => {
				if (e.target.tagName !== 'A') e.preventDefault();
				this.close();
			});
		});

		window.addEventListener('keydown', (e) => {
			if (this.opened && e.key === 'Escape') {
				this.close();
			}
		});

		window.addEventListener('popstate', () => {
			this.close();
		});

		// Добавляем обработчики для всех контейнеров
		this.wrappers.forEach((wrapper) => {
			wrapper.addEventListener('click', (e) => {
				if (this.opened && e.target === wrapper) {
					this.close();
				}
			});
		});
	}

	open(name) {
		if (this.activePopupName === name || this.animating) return;

		if (this.opened) {
			this.close(true);
		}

		// Ищем popup во всех контейнерах
		let popup = null;
		let wrapper = null;

		for (const currentWrapper of this.wrappers) {
			popup = currentWrapper.querySelector(`[data-modal="${name}"]`);
			if (popup) {
				wrapper = currentWrapper;
				break;
			}
		}

		if (!popup) {
			console.warn(`No popup for opener: ${name}`);
			return;
		}

		this.opened = true;
		this.activePopup = popup;
		this.activePopupName = name;
		this.activeWrapper = wrapper;

		wrapper.classList.add('_' + name);

		gsap.set(wrapper, { autoAlpha: 1 });
		gsap.to(wrapper, {
			duration: OPEN_DURATION,
			overwrite: true,
			display: 'flex',
			'--progress': 1,
			ease: 'linear',
			onComplete: () => {
				wrapper.classList.remove('no-pe');
			},
		});

		const completeHandler = () => {
			const focusElement = this.activePopup.querySelector('[data-popup-focus]');

			if (focusElement) {
				focusElement.focus();
			}

			this.animating = false;
		};

		this.animating = true;
		gsap.fromTo(
			this.activePopup,
			{ autoAlpha: 0, scale: 0.98, y: 30, display: 'flex' },
			{
				duration: OPEN_DURATION,
				autoAlpha: 1,
				scale: 1,
				y: 0,
				clearProps: 'transform',
				onComplete: () => {
					completeHandler();
				},
			},
		);

		HTML_CLASSLIST.add('_modal-opened');

		this.openedClass = '_modal-opened-' + name;
		HTML_CLASSLIST.add(this.openedClass);

		PageScroll.disabled();
		this.onOpen.call(name);

		window.history.replaceState({}, '', `#${name}`);
	}

	close(immediate = false) {
		if (this.animating || !this.opened || HTML_CLASSLIST.contains('_popup-opened')) {
			return;
		}

		this.opened = false;
		this.onCloseStart.call(this.activePopupName);

		const wrapper = this.activeWrapper;

		wrapper.classList.add('no-pe');
		gsap.to(wrapper, {
			duration: immediate ? 0 : CLOSE_DURATION,
			display: 'none',
			'--progress': 0,
			ease: 'linear',
		});

		const completeHandler = () => {
			HTML_CLASSLIST.remove('_modal-opened');
			this.activeWrapper.classList.remove(`_${this.activePopupName}`);
			this.activeWrapper.classList.add('no-pe');

			if (this.openedClass) {
				HTML_CLASSLIST.remove(this.openedClass);
				this.openedClass = '';
			}

			this.animating = false;
			this.activePopupName = '';
			this.activePopup = null;
			this.activeWrapper = null;
			PageScroll.enabled();

			window.history.replaceState('', document.title, window.location.pathname + window.location.search);
			this.onClose.call();
		};

		this.animating = true;
		gsap.to(this.activePopup, {
			duration: immediate ? 0 : CLOSE_DURATION,
			autoAlpha: 0,
			scale: 0.98,
			y: 30,
			display: 'none',
			ease: 'linear',
			onComplete: () => {
				completeHandler();
			},
		});
	}

	getPopup(name) {
		for (const wrapper of this.wrappers) {
			const popup = wrapper.querySelector(`[data-modal="${name}"]`);
			if (popup) {
				return popup;
			}
		}
		return null;
	}
}

export default new Modals();
